import { Container, Row, Col } from "react-bootstrap";
import { Calendar, Award, TrendingUp, Users, MapPin, Building2, CheckCircle, Globe } from 'lucide-react';
import img1 from '../../assets/img/about/grupo.jpg';

function Historia() {
    const hitos = [
        {
            year: "2003",
            icon: <MapPin size={24} />,
            title: "Llegada a Bolivia",
            description: "TRUPER expande su mercado a Bolivia"
        },
        {
            year: "2005",
            icon: <Building2 size={24} />,
            title: "Fundación",
            description: "Nace Salcedo Importaciones S.R.L."
        },
        {
            year: "2025",
            icon: <Award size={24} />,
            title: "Premio Maya 2025",
            description: "Mejor importadora de productos ferreteros en Bolivia"
        },
        {
            year: "2026",
            icon: <Globe size={24} />,
            title: "26 Años",
            description: "Líderes en importación ferretera"
        }
    ];

    const valores = [
        { icon: <CheckCircle size={20} />, text: "Representante oficial autorizado" },
        { icon: <CheckCircle size={20} />, text: "Más de 25 años de trayectoria" },
        { icon: <CheckCircle size={20} />, text: "Presencia nacional en Bolivia" },
        { icon: <CheckCircle size={20} />, text: "Compromiso con la calidad" }
    ];

    return (
        <section className="historia-section">
            {/* Fondo decorativo */}
            <div className="historia-background">
                <div className="historia-shape historia-shape-1"></div>
                <div className="historia-shape historia-shape-2"></div>
                <div className="historia-shape historia-shape-3"></div>
            </div>

            <Container className="historia-container">
                {/* Header de la sección */}
                <div className="historia-header text-center mb-5">
                    <div className="historia-badge">
                        <Calendar size={20} />
                        <span>Nuestra Historia</span>
                    </div>
                    <h2 className="historia-main-title">
                        Más de <span className="text-highlight-historia">25 Años</span> de Experiencia
                    </h2>
                    <div className="title-divider-historia"></div>
                </div>

                {/* Contenido principal */}
                <Row className="align-items-center g-5 historia-main-content">
                    {/* Columna de Imagen */}
                    <Col lg={6}>
                        <div className="historia-image-wrapper">
                            {/* Decoración */}
                            <div className="image-decoration"></div>
                            <div className="image-frame"></div>
                            
                            {/* Imagen principal */}
                            <img 
                                src={img1} 
                                alt="Equipo Salcedo Importaciones" 
                                className="historia-image"
                            />

                            {/* Badge flotante */}
                            <div className="floating-badge">
                                <Users size={24} />
                                <div>
                                    <span className="badge-number">100+</span>
                                    <span className="badge-text">Colaboradores</span>
                                </div>
                            </div>

                            {/* Stats sobre la imagen */}
                            <div className="image-stats">
                                {/* <div className="stat-box">
                                    <Award size={30} className="stat-icon" />
                                    <span className="stat-value">26</span>
                                    <span className="stat-label">Años</span>
                                </div> */}
                                <div className="stat-box">
                                    <TrendingUp size={30} className="stat-icon" />
                                    <span className="stat-value">1000+</span>
                                    <span className="stat-label">Productos</span>
                                </div>
                            </div>
                        </div>
                        {/* Lista de valores */}
                                <div className="valores-list">
                                    {valores.map((valor, index) => (
                                        <div 
                                            key={index} 
                                            className="valor-item"
                                            style={{ animationDelay: `${index * 0.1}s` }}
                                        >
                                            <div className="valor-icon">
                                                {valor.icon}
                                            </div>
                                            <span>{valor.text}</span>
                                        </div>
                                    ))}
                                </div>
                    </Col>

                    {/* Columna de Contenido */}
                    <Col lg={6}>
                        <div className="historia-content">
                            {/* Título de la empresa */}
                            <div className="company-title-section">
                                <h3 className="company-name">
                                    Salcedo Importaciones S.R.L.
                                </h3>
                                <p className="company-tagline">
                                    Representantes Oficiales de TRUPER en Bolivia
                                </p>
                            </div>

                            {/* Contenido de la historia */}
                            <div className="historia-text">
                                <p className="historia-intro">
                                    Nuestra historia comienza en <strong>2003</strong>, cuando la reconocida marca mexicana 
                                    <span className="brand-highlight"> TRUPER</span> buscaba expandir su presencia en el mercado boliviano.
                                </p>

                                <p className="historia-body">
                                    Tras un riguroso proceso de selección, el señor <strong>Alejandro Salcedo</strong> fue 
                                    elegido como representante oficial, cumpliendo con todos los estándares de calidad y 
                                    compromiso que TRUPER requería.
                                </p>

                                <p className="historia-body">
                                    El <strong>29 de mayo de 2005</strong>, en la ciudad de Cochabamba, nace oficialmente 
                                    <span className="company-highlight"> Salcedo Importaciones S.R.L.</span>, marcando el inicio 
                                    de una trayectoria de éxito que perdura hasta hoy.
                                </p>

                                
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* Timeline de Hitos */}
                <div className="historia-timeline">
                    <h3 className="timeline-title">Hitos Importantes</h3>
                    <div className="timeline-wrapper">
                        {hitos.map((hito, index) => (
                            <div 
                                key={index} 
                                className="timeline-item"
                                style={{ animationDelay: `${index * 0.2}s` }}
                            >
                                <div className="timeline-icon-wrapper">
                                    <div className="timeline-icon">
                                        {hito.icon}
                                    </div>
                                    <div className="timeline-line"></div>
                                </div>
                                <div className="timeline-content">
                                    <span className="timeline-year">{hito.year}</span>
                                    <h4 className="timeline-item-title">{hito.title}</h4>
                                    <p className="timeline-description">{hito.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* CTA final */}
                {/* <div className="historia-cta">
                    <div className="cta-content">
                        <h3 className="cta-title">
                            Forma Parte de Nuestra Historia
                        </h3>
                        <p className="cta-description">
                            Únete a nosotros y descubre la calidad que nos ha mantenido líderes por más de 20 años
                        </p>
                        <div className="cta-buttons">
                            <a href="/contacto" className="btn-historia-primary">
                                Contáctanos
                            </a>
                            <a href="/productos" className="btn-historia-secondary">
                                Ver Productos
                            </a>
                        </div>
                    </div>
                </div> */}
            </Container>
        </section>
    );
}

export default Historia;